import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  ownerCorporate: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
};

export const corporateSlice = createSlice({
  name: 'corporate',
  initialState,
  reducers: {
    fetchOwnerCorporateListRequest: (state) => {
      state.ownerCorporate.loading = true;
      state.ownerCorporate.error = null;
    },
    fetchOwnerCorporateListSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.ownerCorporate.loading = false;
      state.ownerCorporate.data = data;
      state.ownerCorporate.page = page;
      state.ownerCorporate.pageSize = pageSize;
      state.ownerCorporate.totalPages = totalPages;
      state.ownerCorporate.totalCount = totalRecords;
      state.ownerCorporate.sortOn = sortOn;
      state.ownerCorporate.sortDir = sortDir;
    },
    fetchOwnerCorporateListError: (state, {payload}) => {
      state.ownerCorporate.loading = false;
      state.ownerCorporate.error = payload;
    },
  },
});

export const {
  fetchOwnerCorporateListRequest,
  fetchOwnerCorporateListSuccess,
  fetchOwnerCorporateListError,
} = corporateSlice.actions;

export default corporateSlice.reducer;
